import { store } from '../../../../redux/store'
import * as actions from './redux/actions'

export default function ({ title, x, y, height, width, description, position, tooltipOffsets }) {
  store.dispatch(actions.addWalkStep({ x, y, height, width, description, position, title, tooltipOffsets }))
}
